<template>
  <d2-container>
    <el-button type="primary" size="mini" icon="el-icon-circle-plus" @click="handleAddScene">新增场景</el-button>
    <el-table :data="list" style="margin-top: 20px" border stripe>
      <el-table-column prop="id" label="ID" align="center" width="80" />
      <el-table-column prop="name" label="名称" align="center" />
      <el-table-column prop="json" label="预览" align="center">
        <template slot-scope="scope">
          <AnimationCanvas v-if="scope.row.json" :flow="parseFlow(scope.row.json)" :width="240" :height="220" />
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEditScene(scope.row.id)">编辑</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 20px; text-align: right;"
      background
      layout="total, prev, pager, next, jumper"
      :total="total"
      :page-size="query.pageSize"
      :current-page="query.currentPage"
      @current-change="handlePageChange"
    />
  </d2-container>
</template>

<script>
import { getAnimFlowList, addAnimFlow, updateAnimFlow, deleteAnimFlow } from '@/api/merchant/botAnimFlow'
import uploadFile from '@/components/uploadFile/index.vue'
import AnimationCanvas from '@/components/AnimationCanvas.vue'
export default {
  name: 'AnimFlowManager',
  components: { uploadFile, AnimationCanvas },
  data () {
    return {
      list: [],
      total: 0,
      query: {
        currentPage: 1,
        pageSize: 10
      },
      dialogVisible: false,
      dialogStatus: 'add',
      form: {
        id: null,
        name: '',
        url: '',
        introduce: ''
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        url: [{ required: true, message: '请输入场景URL', trigger: 'blur' }],
        introduce: [{ required: true, message: '请输入简介', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle () {
      return this.dialogStatus === 'add' ? '新增动画场景' : '编辑动画场景'
    }
  },
  methods: {
    fetchList () {
      getAnimFlowList({
        currentPage: this.query.currentPage,
        pageSize: this.query.pageSize
      }).then(res => {
        this.list = res.records || []
        this.total = parseInt(res.total) || 0
      })
    },
    handlePageChange (page) {
      this.query.currentPage = page
      this.fetchList()
    },
    handleAddScene () {
      window.open('/tools', '_blank')
    },
    handleEditScene (id) {
      window.open(`/tools?id=${id}`, '_blank')
    },
    handleSubmit () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        if (this.dialogStatus === 'add') {
          addAnimFlow(this.form).then(() => {
            this.$message.success('新增成功')
            this.dialogVisible = false
            this.fetchList()
          })
        } else {
          updateAnimFlow(this.form.id, this.form).then(() => {
            this.$message.success('编辑成功')
            this.dialogVisible = false
            this.fetchList()
          })
        }
      })
    },
    handleDelete (id) {
      this.$confirm('确定要删除该动画场景吗？', '提示', { type: 'warning' })
        .then(() => {
          deleteAnimFlow(id).then(() => {
            this.$message.success('删除成功')
            this.fetchList()
          })
        })
    },
    handleFileChange (val) {
      this.form.url = val
    },
    parseFlow (json) {
      try {
        return typeof json === 'string' ? JSON.parse(json) : json
      } catch (e) {
        return null
      }
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
